import React from "react";
import Version from "@components/version";
import Phrases from "@helpers/Phrases";
import AnalyticsScripts from "@components/common/AnalyticsScripts";
import { Box, Grid, Typography } from "@mui/material";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import {
  FooterMain,
  FooterContainer,
  FooterContainerWrapper,
  FooterContent,
  FooterLogo,
  ClientLogos,
  FooterClientLogosWrapper,
} from "./Footer.styles";

const Footer: React.FC = () => {
  return (
    <FooterMain>
      <FooterClientLogosWrapper>
        <Typography variant="h2" color="secondary.main" paddingY={2}>
          Top teams build their product with TestTheTest
        </Typography>
        <ClientLogos>
          <img src="/assets/images/footer-logos.svg" alt="logos" />
        </ClientLogos>
      </FooterClientLogosWrapper>
      <FooterContainerWrapper>
        <FooterContainer>
          <FooterContent>
            <Grid container id="FooterBlocks">
              <Grid className="FooterColumn First" item md={3}>
                <FooterLogo href="/">
                  <img
                    src="/assets/images/logo-horizontal.svg"
                    alt={Phrases.HTML_TITLE}
                  />
                </FooterLogo>
                <br />
                <br />
                <strong>Email:</strong>
                <> office&#64;testthetest.com</>
                <br />
                <strong>Phone:</strong>
                <> +1 (201) 472-5592</>
                <br />
                <div>
                  <a
                    href="https://www.x.com/theTestTheTest"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <TwitterIcon />
                  </a>
                  &nbsp;
                  <a
                    href="https://www.linkedin.com/company/testthetest/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <LinkedInIcon />
                  </a>
                </div>
                <p>
                  &copy; {new Date().getFullYear()} Bunt Inc. All rights
                  reserved. Version: <Version />
                </p>
              </Grid>
              <Grid className="FooterColumn" item md={3}>
                <Box className="FooterColumnContainer">
                  <p>
                    <a href="/login">Login</a>
                  </p>
                  <p>
                    <a href="https://blog.testthetest.com">Blog</a>
                  </p>
                  <p>
                    <a href="/pricing">Pricing</a>
                  </p>
                  {/* <p>
                    <a href="/careers">Careers</a>
                  </p> */}
                  <p>
                    <a href="/terms/general">Terms of Service</a>
                  </p>
                </Box>
              </Grid>
              <Grid className="FooterColumn" item md={3}>
                <Box className="FooterColumnContainer">
                  <p>
                    <strong>In New York</strong>
                  </p>
                  <p>10th Floor, Spaces Midtown South</p>
                  <p>401 Park Avenue</p>
                  <p>New York, NY 10016</p>
                  <p>United States</p>
                </Box>
              </Grid>
              <Grid className="FooterColumn" item md={3}>
                <Box className="FooterColumnContainer">
                  <p>
                    <strong>In London</strong>
                  </p>
                  <p>86-90 Paul Street</p>
                  <p>London, EC2A 4NE</p>
                  <p>United Kingdom</p>
                  <p>
                    <a href="https://www.buntlabs.com">www.buntlabs.com</a>
                  </p>
                </Box>
              </Grid>
            </Grid>
          </FooterContent>
        </FooterContainer>
      </FooterContainerWrapper>
      <AnalyticsScripts />
    </FooterMain>
  );
};

export default Footer;
